import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Toast } from 'primereact/toast';
import { translatedMessage } from '../../service/LanguageService';
import { CompetitionService } from '../../service/CompetitionService';
// import { Checkbox } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useFormik } from 'formik';
import { classNames } from 'primereact/utils';
import { InputTextarea } from 'primereact/inputtextarea';

const CompetitionJobApprovalEditDialog = (props) => {
    const [competition, setCompetition] = useState(null);

    const toast = useRef(null);

    const competitionService = useMemo(() => new CompetitionService(), []);

    useEffect(() => {
        setCompetition({ ...props?.value, jobApproval: props?.value?.jobApproval || '', jobApprovalNormativeAct: props?.value?.jobApprovalNormativeAct || '' });
    }, [props.value]);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: competition,
        validate: (data) => {
            let errors = {};

            // if(data.jobApprovalRequired && (!data.jobApproval || data.jobApproval.trim() === '')) {
            //     errors.jobApproval = translatedMessage('form.error.competition.jobApproval.required');
            // }

            // if(data.jobApprovalRequired && (!data.jobApprovalNormativeAct || data.jobApprovalNormativeAct.trim() === '')) {
            //     errors.jobApprovalNormativeAct = translatedMessage('form.error.competition.jobApprovalNormativeAct.required');
            // }

            if (data.jobApproval && (!data.jobApprovalNormativeAct || data.jobApprovalNormativeAct.trim() === '')) {
                errors.jobApprovalNormativeAct = translatedMessage('form.error.competition.jobApprovalNormativeAct.required');
            }

            return errors;
        },
        onSubmit: (data) => {
            // console.log(data);
            saveCompetition(data);
        }
    });

    const hideDialog = () => {
        if (typeof props.visibleSetter === 'function') {
            props.visibleSetter(false);
        }
        formik.resetForm();
    };

    const saveCompetition = (data) => {
        competitionService.saveCompetitionJob(data)
            .then((savedTest) => {
                if (typeof props.afterSave === 'function') {
                    props.afterSave(savedTest, true);
                }
                hideDialog();
                formik.resetForm();
            })
            .catch((error) => {
                if (typeof props.afterSave === 'function') {
                    props.afterSave(null, false, error);
                }
            });
    };

    const dialogFooter = (
        <>
            <Button label={translatedMessage('generic.cancel')} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label={translatedMessage('generic.save')} icon="pi pi-save" className="p-button-text" form="jobApproval-form" type="submit" />
        </>
    );

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error text-align-left">{formik.errors[name]}</small>;
    };

    return (
        <>
            <Toast ref={toast} />

            <Dialog
                visible={props.visible}
                header={translatedMessage('competition.requirements.jobApproval')}
                modal
                className="pcn-dialog p-fluid"
                footer={dialogFooter}
                onHide={hideDialog}
            >
                <form id="jobApproval-form" onSubmit={formik.handleSubmit}>
                    {/* <div className="field-checkbox text-left mb-5">
                        <Checkbox inputId="jobApprovalRequired" name="jobApprovalRequired" checked={formik.values?.jobApprovalRequired}
                            onChange={formik.handleChange} />
                        <label htmlFor="jobApprovalRequired">{translatedMessage("competition.requirements.jobApproval.required")}</label>
                    </div> */}

                    <div className="p-inputgroup">
                        <span className="p-float-label">
                            <InputTextarea type="text" id="jobApproval" name="jobApproval" value={formik.values?.jobApproval}
                                onChange={formik.handleChange} className={classNames({ 'p-invalid': isFormFieldValid('jobApproval') })}
                                rows={5} cols={30} autoResize
                                maxLength={10000}
                                tooltip={translatedMessage("field.character.maxLength", "10.000")}
                                tooltipOptions={{ position: 'top' }} />
                            <label htmlFor="jobApproval" className={classNames({ 'p-error': isFormFieldValid('jobApproval') })}>
                                {translatedMessage("competition.requirements.jobApproval.info")} *
                            </label>
                        </span>
                    </div>
                    {getFormErrorMessage('jobApproval')}

                    <div className="p-inputgroup mt-5">
                        <span className="p-float-label">
                            <InputTextarea type="text" id="jobApprovalNormativeAct" name="jobApprovalNormativeAct" value={formik.values?.jobApprovalNormativeAct}
                                onChange={formik.handleChange} className={classNames({ 'p-invalid': isFormFieldValid('jobApprovalNormativeAct') })}
                                rows={5} cols={30} autoResize
                                maxLength={10000}
                                tooltip={translatedMessage("field.character.maxLength", "10.000")}
                                tooltipOptions={{ position: 'top' }} />
                            <label htmlFor="jobApprovalNormativeAct" className={classNames({ 'p-error': isFormFieldValid('jobApprovalNormativeAct') })}>
                                {translatedMessage("competition.requirements.jobApprovalNormativeAct")} *
                            </label>
                        </span>
                    </div>
                    {getFormErrorMessage('jobApprovalNormativeAct')}


                </form>
            </Dialog>
        </>
    );
};

export default CompetitionJobApprovalEditDialog;
